export default [
    {
      path: '/comment',
      name: 'comment-read',
      component: () => import('@/views/comment/comment-list/CommentList.vue'),
      meta: {
        resource: 'Comment',
        action: 'read',
      },
    },
    {
        path: '/comment/create',
        name: 'comment-create',
        component: () => import('@/views/comment/comment-form/CommentForm.vue'),
        meta: {
          resource: 'Comment',
          action: 'create',
        },
    },
    
    
  ]
  